import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Story from "@/pages/Story";
import FarmersImpact from "@/pages/FarmersImpact";
import NaturalFarming from "@/pages/NaturalFarming";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Contact from "@/pages/Contact";
import AdminOrders from "@/pages/AdminOrders";

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <div className="min-h-screen bg-[#FAFAF8] font-[Outfit] text-[#2C2C2A]">
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/our-story" element={<Story />} />
            <Route path="/farmers-impact" element={<FarmersImpact />} />
            <Route path="/natural-farming" element={<NaturalFarming />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
          </Routes>
          <Footer />
          <Toaster richColors position="bottom-right" />
        </div>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
